module.exports = __webpack_public_path__ + "img/partner.cc5cf740.png";